import { useEffect, useMemo, useState, useCallback, useRef } from "react";
import Slider from "rc-slider";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../UI/loader";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";
import UploadService from "../../Services/FileUploadServices";
import { Link, useHistory, useParams } from "react-router-dom";
import { campaignAction } from "../../store/campaign-store";
import { authActions } from "../../store/auth";
import { cuteToast } from "../UI/cute";
import axios from "axios";
import { FcNext, FcPrevious } from "react-icons/fc";
import ReactPlayer from 'react-player';

const VideoBackgroundModal = (props) => {
  const [uploadFiles, setUploadFiles] = useState([]);
  const [showDropzone, setShowDropzone] = useState(true);
  const [showUploadFiles, setShowUploadFiles] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState(0);
  const [progressSection, setProgressSection] = useState(false);
  const [source, setSource] = useState();
  const [media, setMedia] = useState([]);
  const editSlideData = useSelector((state) => state.campaign.editSlideData);

  //search video on pixabay
  const inputRef = useRef();
  const [showImageSearchResult, setShowImageSearchResult] = useState(false);
  const [searchImageResults, setSearchImageResults] = useState({});
  const [searchImagePexelsResults, setSearchImagePexelsResults] = useState({});
  const [keyword, setKeyword] = useState("");
  const [available, setAvailable] = useState(0);
  const [pageNumber, setpageNumber] = useState(1);

  const { sendRequest: fetchMedia } = useHttp();
  // const { sendRequest: createVideo } = useHttp();

  const token = useSelector((state) => state.auth.token);
  const { camp_id } = useParams();
  const dispatch = useDispatch();
  const responseData = (response) => {
    if (response.length > 0) {
      setMedia(response);
      // dispatch(campaignAction.setGallery({ gallery: response }));
      // dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: true }));
    }
  };

  const history = useHistory();

  useEffect(() => {
    fetchMedia({ url: endPoints.myMedia, method: "GET" }, responseData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [trimDuration, setTrimDuration] = useState({
    length: 0,
    start: 0,
    end: 0,
    duration: 0,
    trim_start: 0,
    trim_end: 0,
    status: false,
  });

  const [videoStats, setVideoStats] = useState({
    defaultHeight: 1080,
    defaultWidth: 1920,
    inputHeight: 0,
    inputWidth: 0,
  });

  const single_slide_data = useSelector(
    (state) => state.campaign.single_slide_data
  );
  // const single_layer = useSelector((state) => state.campaign.single_layer);
  console.log(showUploadFiles);
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        // setTrimDuration({ ...trimDuration, status: false });
        setStatus(false);
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        console.log(binaryStr);
        var blob = new Blob([e.target.result], { type: file.type }), // create a blob of buffer
          url = URL.createObjectURL(blob), // create o-URL of blob
          video = document.createElement("video"); // create video element

        video.preload = "metadata"; // preload setting
        video.addEventListener("loadedmetadata", function () {
          // when enough data loads
          console.log(video.videoWidth); // show duration
          URL.revokeObjectURL(url); // clean up

          setTrimDuration({
            ...trimDuration,
            trim_end: parseInt(single_slide_data.duration),
            end: parseInt(single_slide_data.duration),
            duration: Math.round(video.duration),
          });

          setVideoStats({
            ...videoStats,
            inputWidth: video.videoWidth,
            inputHeight: video.videoHeight,
          });

          // setSource(source + `#t=0,${parseInt(single_slide_data.duration)}`);

          // ... continue from here ...
        });
        video.src = url;
      };
      reader.readAsArrayBuffer(file);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    getRootProps: getRootFirstProps,
    getInputProps: getInputFirstProps,
    isFocused,
    isDragAccept,
    isDragReject,
    fileRejections,
    acceptedFiles,
  } = useDropzone({
    accept: "video/quicktime,video/mp4,video/x-flv,video/*",
    maxFiles: 1,
    onDrop,
    validator: filesizeValidator,
  });

  const {
    getRootProps: getRootSecondaryProps,
    getInputProps: getInputSecondaryProps,
    fileRejections: fileRejectionsSecondaryUpload,
    acceptedFiles: acceptedFilesSecondaryUpload,
  } = useDropzone({
    accept: "video/quicktime,video/mp4,video/x-flv,video/*",
    maxFiles: 1,
    validator: filesizeValidator,
  });

  function filesizeValidator(file) {
    if (file.size > 26214400) {
      return {
        code: "file-too-large",
        message: `File Size should not be more than ${formatBytes(15728640)}`,
      };
    }

    return null;
  }

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <div key={file.path}>
      {file.path} - {file.size} bytes
      <div className="d-inline-flex text-danger ms-sm-3">
        {errors.map((e) => (
          <span key={e.code}>{e.message}</span>
        ))}
      </div>
    </div>
  ));

  const fileRejectionSecondaryItems = fileRejectionsSecondaryUpload.map(
    ({ file, errors }) => (
      <div key={file.path}>
        {file.path} - {file.size} bytes
        <div className="d-inline-flex text-danger ms-sm-3">
          {errors.map((e) => (
            <span key={e.code}>{e.message}</span>
          ))}
        </div>
      </div>
    )
  );

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const focusedStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#000000",
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isFocused, isDragAccept, isDragReject]
  );

  useEffect(() => {
    // console.log('here');
    async function checkCampaignData(type) {
      if (type === "first") {
        setShowDropzone(false);
        setShowUploadFiles(true);

        // console.log(showUploadFiles)
        setUploadFiles(acceptedFiles);
        const url = URL.createObjectURL(acceptedFiles[0]);
        setSource(url);
      }

      if (type === "secondary") {
        setShowDropzone(false);
        setShowUploadFiles(true);
        setShowFiles(false);

        setUploadFiles(acceptedFilesSecondaryUpload);
        const url = URL.createObjectURL(acceptedFiles[0]);
        setSource(url);
      }

      // console.log(campaign_name)
    }

    if (acceptedFiles && acceptedFiles.length > 0) {
      checkCampaignData("first");
    }

    if (
      acceptedFilesSecondaryUpload &&
      acceptedFilesSecondaryUpload.length > 0
    ) {
      checkCampaignData("secondary");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles, acceptedFilesSecondaryUpload]);

  const handleChange = (event, type) => {
    event.preventDefault();

    setSource("");
    setShowDropzone(true);
  };

  const handleSave = () => {
    if (
      trimDuration.trim_end - trimDuration.trim_start !==
      parseInt(single_slide_data.duration)
    ) {
      cuteToast({
        type: "error",
        message: `Trim Duration Should Be ${single_slide_data.duration}s`,
        timer: 5000,
        title: "Error",
      });
      return false;
    } else {
      dispatch(
        authActions.setLoaderStatus({
          status: true,
          loader_text:
            "Please wait... Applying your background video <br /> Please be patient. It may take some time to Upload and Trim your video on our server",
        })
      );
      if (uploadFiles.length === 0) {
        // media url

        createTrimRequest(source);
      } else {
        UploadService.uploadVideo(uploadFiles[0], token, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        })
          .then((response) => {
            if (response.status === 200) {
              createTrimRequest(response.data.url);
            }
          })
          .catch(() => {
            setProgress(0);
            // setMessage("Could not upload the file!");
            setUploadFiles(undefined);
            setShowUploadFiles(true);
            setShowFiles(false);
            setShowDropzone(false);
            setProgressSection(false);
          });
      }
    }
  };

  const createTrimRequest = (url) => {
    // console.log(trimDuration.trim_start, trimDuration.trim_end);

    // createVideo(
    //   {
    //     url: endPoints.trimVideo,
    //     method: "POST",
    //     body: {
    //       camp_id,
    //       start_point: trimDuration.trim_start,
    //       end_point: trimDuration.trim_end,
    //       url,
    //     },
    //   },
    //   (response) => {
    //     if (response && response.url) {
    let single_slide_clone = { ...single_slide_data };

    var assets = single_slide_clone.assets;
    var newData = assets.map((slide_data) => {
      var a = { ...slide_data };
      // console.log(a);
      if (a.layerName === "bg_video") {
        // console.log(a);
        a = {
          ...a,
          src: url,
          trim_start: trimDuration.trim_start,
          trim_end: trimDuration.trim_end,
        };
      }
      return a;
    });

    single_slide_clone.assets = newData;

    var newEditData = { ...editSlideData };
    newEditData.bg_video = url;

    dispatch(campaignAction.setSlideData({ data: newEditData }));

    dispatch(campaignAction.setSingleSlideData({ data: single_slide_clone }));
    dispatch(campaignAction.appendVideoData());
    dispatch(authActions.setLoaderStatus({ status: false, loader_text: "" }));

    history.push(`/campaign/${camp_id}/edit`);
    //     }
    //   }
    // );
  };

  const handleTrimVideo = (value) => {
    // console.log(value);
    let start = value[0];
    let end = value[1];

    let startDuration = Math.floor((start / 100) * trimDuration.duration);
    let endDuration = Math.floor((end / 100) * trimDuration.duration);

    let slide_start = Math.round(
      (parseInt(startDuration) / parseInt(trimDuration.duration)) * 100 + 1
    );
    let slide_end = Math.round(
      (parseInt(endDuration) / parseInt(trimDuration.duration)) * 100 + 1
    );

    setTrimDuration({
      ...trimDuration,
      trim_start: startDuration,
      trim_end: endDuration,
      start: slide_start,
      end: slide_end,
    });

    setSource(source.split("#")[0] + `#t=${startDuration},${endDuration}`);
  };

  const handleVideoSource = (url) => {
    // const video_duration = await getVideoDuration(url);
    // setTrimDuration({ ...trimDuration, status: false });

    setStatus(false);
    var video = document.createElement("video"); // create video element

    video.preload = "metadata"; // preload setting
    video.addEventListener("loadedmetadata", function () {
      // when enough data loads
      //return video.duration; // show duration
      setTrimDuration({
        ...trimDuration,
        trim_start: 0,
        trim_end: parseInt(single_slide_data.duration),
        start: 0,
        end: parseInt(single_slide_data.duration),
        duration: Math.round(video.duration),
        status: true,
      });

      setVideoStats({
        ...videoStats,
        inputWidth: video.videoWidth,
        inputHeight: video.videoHeight,
      });
      // console.log(url)
      setSource(url + `#t=0,${parseInt(single_slide_data.duration)}`);
      setUploadFiles([]);
    });
    video.src = url;
  };

  useEffect(() => {
    setTimeout(() => {
      if (!status) {
        setStatus(true);
      }
    }, 500);
  }, [status]);

  const handleChangeTrim = (e, type) => {
    // setTrimDuration({ ...trimDuration, status: false });
    setStatus(false);

    var slide_duration = parseInt(single_slide_data.duration);
    if (type === "start") {
      var end_time = parseInt(e.target.value) + slide_duration;

      if (e.target.value <= trimDuration.duration) {
        setTrimDuration({
          ...trimDuration,
          trim_start: e.target.value,
          trim_end: end_time,
        });
      }
      // setTrimDuration({ ...trimDuration, status: true });
    } else {
      var start_time = parseInt(e.target.value) - slide_duration;
      if (e.target.value <= trimDuration.duration) {
        setTrimDuration({
          ...trimDuration,
          trim_end: e.target.value,
          trim_start: start_time,
        });
      }
    }
  };

  useEffect(() => {
    async function searchImages() {
      try {
        const apiUrl = `https://pixabay.com/api/videos/?key=${process.env.REACT_APP_PIXABAY}&q=${keyword}&video_type=all&safesearch=true&per_page=15&page=${pageNumber}`;
        const pexelsUrl = `https://api.pexels.com/videos/search?query=${keyword}&per_page=15&page=${pageNumber}&size=medium`;
        const response = await axios.get(apiUrl);
        // console.log(response.data);
        const res = await response.data.hits;
        setShowImageSearchResult(true);
        if (res.length !== 0) {
          if (res.length < 15) {
            const pexelsResponse = await axios(pexelsUrl, {
              headers: {
                Authorization: process.env.REACT_APP_PEXELS,
              },
            });
            const resPexels = await pexelsResponse.data.videos;
            if (resPexels.length !== 0) {
              setSearchImagePexelsResults(resPexels);
            }
          }
          setSearchImageResults(res);
          setAvailable(2);
        } else {
          const pexelsResponse = await axios(pexelsUrl, {
            headers: {
              Authorization: process.env.REACT_APP_PEXELS,
            },
          });
          const resPexels = await pexelsResponse.data.videos;

          if (resPexels.length !== 0) {
            setSearchImagePexelsResults(resPexels);
            setAvailable(2);
          } else {
            setSearchImagePexelsResults([]);
            setSearchImageResults([]);
            setAvailable(1);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }

    if (keyword) {
      searchImages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  const handleClick = async (event, type) => {
    event.preventDefault();
    // console.log(event.target.innerText)
    if (type === "search") {
      if (keyword.length > 0) {
        try {
          const apiUrl = `https://pixabay.com/api/videos/?key=${process.env.REACT_APP_PIXABAY}&q=${keyword}&video_type=all&safesearch=true&per_page=30&page=${pageNumber}`;
          const pexelsUrl = `https://api.pexels.com/videos/search?query=${keyword}&per_page=15&page=${pageNumber}&size=medium`;
          const response = await axios.get(apiUrl);
          // console.log(response.data);
          const res = await response.data.hits;
          setShowImageSearchResult(true);
          if (res.length !== 0) {
            if (res.length < 15) {
              const pexelsResponse = await axios(pexelsUrl, {
                headers: {
                  Authorization: process.env.REACT_APP_PEXELS,
                },
              });
              const resPexels = await pexelsResponse.data.videos;
              if (resPexels.length !== 0) {
                setSearchImagePexelsResults(resPexels);
              }
            }
            setSearchImageResults(res);
            setAvailable(2);
          } else {
            const pexelsResponse = await axios(pexelsUrl, {
              headers: {
                Authorization: process.env.REACT_APP_PEXELS,
              },
            });
            const resPexels = await pexelsResponse.data.videos;

            if (resPexels.length !== 0) {
              setSearchImagePexelsResults(resPexels);
              setAvailable(2);
            } else {
              setSearchImagePexelsResults([]);
              setSearchImageResults([]);
              setAvailable(1);
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        inputRef.current.focus();
      }
    }
  };

  return (
    <div className="templateList">
      <div className="container-fluid">
        <div className="row">
          <div
            className="col-sm-7 p-10-12 border-1  mt-5"
            style={{ borderRight: "#e1e1e1 2px solid" }}
          >
            <div className="container">
              <div className="row">
                {/* <div className="col-md-12 m-auto">
                 */}
                <div className="col-md-12">
                  <Link to={`/campaign/${camp_id}/edit`} className="btn">
                    Back
                  </Link>
                </div>
                <div className="col-xl-9 col-lg-7 col-md-12 m-auto">
                  <div className="tab-content p-4 pb-0" id="nav-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="nav-local"
                      role="tabpanel"
                      aria-labelledby="nav-local-tab"
                    >
                      <div className="v_c_import mb-4 text-center">
                        {showDropzone && !source && (
                          <>
                            <div
                              className="image-upload"
                              {...getRootFirstProps({ style })}
                            >
                              <label
                                style={{ cursor: "pointer" }}
                                htmlFor="file_upload"
                              >
                                <div className="h-100">
                                  <div className="dplay-tbl">
                                    <div className="dplay-tbl-cell">
                                      <i>
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/upload.png"
                                          }
                                          className="img-fluid"
                                          alt="img"
                                        />
                                      </i>
                                      <input {...getInputFirstProps()} />
                                      <h6 className="pt-2 m-0">
                                        Drag &amp; drop your video file here{" "}
                                        <br />
                                        <label className="text-danger">
                                          Note :
                                        </label>{" "}
                                        Recommended video dimension{" "}
                                        {videoStats.defaultWidth} *{" "}
                                        {videoStats.defaultHeight} px
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                                {/* <!--upload-content-->  */}
                                {/* <input type="file" name="image_name" id="file_upload" className="image-input" data-traget-resolution="image_resolution" accept="video/quicktime,video/mp4,video/x-flv,video/*"/> */}
                              </label>
                            </div>
                            <div className="my-2">{fileRejectionItems}</div>
                          </>
                        )}

                        {source && (
                          <>
                            <video
                              className="VideoInput_video"
                              width="100%"
                              height={400}
                              controls
                              src={source}
                              loop
                            />
                            <label className="import-file-name text-center pull-left">
                              start :{" "}
                              <input
                                type="text"
                                value={trimDuration.trim_start}
                                style={{
                                  width: "35px",
                                  textAlign: "center",
                                  height: "23px",
                                }}
                                onChange={(e) => {
                                  handleChangeTrim(e, "start");
                                }}
                              />{" "}
                              :{" "}
                              <input
                                type="text"
                                value={trimDuration.trim_end}
                                style={{
                                  width: "35px",
                                  textAlign: "center",
                                  height: "23px",
                                }}
                                onChange={(e) => {
                                  handleChangeTrim(e, "end");
                                }}
                              />{" "}
                              end
                            </label>
                            <label className="import-file-size pull-right">
                              Selected duration :{" "}
                              <b
                                className={`${
                                  parseInt(
                                    trimDuration.trim_end -
                                      trimDuration.trim_start
                                  ) === parseInt(single_slide_data.duration)
                                    ? "text-success"
                                    : "text-danger"
                                }`}
                              >
                                {trimDuration.trim_end -
                                  trimDuration.trim_start}
                              </b>
                              s
                            </label>
                            {status && (
                              <div className=" mt-5 " id="backgroundVideo">
                                <Slider
                                  range
                                  draggableTrack={true}
                                  allowCross={false}
                                  defaultValue={[
                                    Math.round(
                                      (parseInt(trimDuration.start) /
                                        parseInt(trimDuration.duration)) *
                                        100 +
                                        1
                                    ),
                                    Math.round(
                                      (parseInt(trimDuration.end) /
                                        parseInt(trimDuration.duration)) *
                                        100 +
                                        1
                                    ),
                                  ]}
                                  onAfterChange={handleTrimVideo}
                                  trackStyle={[
                                    {
                                      backgroundColor: "#aa4ee4",
                                      height: "25px",
                                      marginTop: "-10px",
                                    },
                                    {
                                      backgroundColor: "green",
                                    },
                                  ]}
                                  // handleStyle={[{ backgroundColor: 'yellow' }, { backgroundColor: 'gray' }]}
                                  railStyle={{
                                    backgroundColor: "#372e58",
                                    height: "25px",
                                    padding: "10px 0px",
                                    marginTop: "-10px",
                                    borderRadius: 0,
                                  }}
                                />
                              </div>
                            )}
                          </>
                        )}

                        {progressSection && (
                          <>
                            <div className="progress">
                              <div
                                className="progress-bar progress-bar-info progress-bar-striped"
                                role="progressbar"
                                aria-valuenow={progress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: progress + "%" }}
                              >
                                {progress}%
                              </div>
                            </div>
                            <Loader />
                          </>
                        )}

                        {showFiles && (
                          <>
                            <div className="row">
                              {/* <div className="col-md-2 col-6"> */}
                              <div className="rv_col mb-4 localfile text-center">
                                <button
                                  className="d-block border-0 bg-transparent mx-auto"
                                  onClick={(e) =>
                                    handleChange(e, "showUploadFiles")
                                  }
                                >
                                  <figure className="mt-2 mb-0">
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/video-thumb.png"
                                      }
                                      className=""
                                      alt="img"
                                      data-name={acceptedFiles[0].name}
                                      data-category="localfile"
                                    />
                                  </figure>
                                  <figcaption className="p-2">
                                    <h6>{acceptedFiles[0].name}</h6>
                                  </figcaption>
                                </button>
                              </div>
                              <div
                                className="rv_col mb-4 localfile text-center secondary-upload"
                                {...getRootSecondaryProps({})}
                              >
                                <button
                                  className="d-block border-0 bg-transparent mx-auto"
                                  // onClick={(e)=>handleChange(e,'secondaryUpload')}
                                >
                                  <figure className="mt-5 mb-0">
                                    <input {...getInputSecondaryProps()} />
                                    <i className="fas fa-plus"></i>
                                  </figure>
                                </button>
                              </div>
                              {/* </div> */}
                            </div>
                            <div className="my-2">
                              {fileRejectionSecondaryItems}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="iv_footer">
                        <div className="note_rw text-left pt-2 pb-3">
                          {!source && (
                            <>
                              <span className="text-danger">NOTE :</span> You
                              can select only 1 file. Supports MP4, MKV, MPEG,
                              3GP formats with max file size of 15MB.
                            </>
                          )}
                          {source && (
                            <>
                              <span className="text-danger">NOTE :</span> Please
                              select or trim the {single_slide_data.duration}s
                              video.
                            </>
                          )}
                        </div>
                        <div className="btn_wrap_p ">
                          {source && (
                            <>
                              {" "}
                              <button
                                className="btn btn2 me-2 float-left"
                                onClick={(e) => handleChange(e, "showFiles")}
                              >
                                Upload New File
                              </button>
                              <button
                                className="btn btn2 me-2 pull-right"
                                onClick={(e) => handleSave(e, "showFiles")}
                              >
                                Save and Close
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-5" style={{}}>
            <div className="row" style={{ marginTop: "4%", height: "4" }}>
              <div className="col-sm-12 text-center">
                <h1>Media </h1>
              </div>
              <div className="border-bottom"></div>
              <ul className="nav nav-tabs p-4" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    Search
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                  >
                    Gallery
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="row">
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control shadow-none"
                          placeholder="Enter Keyword"
                          aria-label="Recipient's username"
                          aria-describedby="button-addon2"
                          value={keyword}
                          onChange={(event) => setKeyword(event.target.value)}
                          ref={inputRef}
                        />
                        <button
                          className="btn btn-outline-secondary shadow-none p-2"
                          type="button"
                          id="button-addon2"
                          onClick={(event) => handleClick(event, "search")}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      {showImageSearchResult && (
                        <div className="container">
                          <div className="row prq-result-img-wrapper">
                            {available === 2 && (
                              <>
                                {searchImageResults.length > 0 &&
                                  searchImageResults.map(({ id, picture_id ,videos }) => (
                                    <div className="col-sm-3 mb-2 pe-0" key={picture_id}>
                                      <div className="player-wrapper">
                                        {/* <video
                                          src={`${videos.small.url}#t=1.5`}
                                          preload={true}
                                          loop
                                          height="100%"
                                          width="100%"
                                          // onMouseOver={playMovie}
                                          // onMouseOut={stopMovie}
                                          onClick={(e) =>
                                            handleVideoSource(videos.large.url)
                                          }
                                        /> */}
                    
                                          <ReactPlayer 
                                            url={`${videos.small.url}#t=1.5`} 
                                            className="w-100 react-player"
                                            height="90px"
                                            id={`video_player_${id}`}
                                            light={`https://i.vimeocdn.com/video/${picture_id}_200x150.jpg`}
                                            onError={e => console.log('onError', e)}
                                            key={id}
                                            onClickPreview={(e) =>
                                              handleVideoSource(videos.large.url)
                                            }
                                          />
                                      </div>
                                    </div>
                                  ))}
                                {searchImagePexelsResults.length > 0 &&
                                  searchImagePexelsResults.map(
                                    ({ id, image,video_files }) => (
                                      <div className="col-sm-3" key={id}>
                                        <div className="">
                                          {/* <video
                                            src={`${
                                              video_files[
                                                video_files.findIndex(
                                                  (obj) => obj.quality === "sd"
                                                )
                                              ].link
                                            }#t=1.5`}
                                            //   preload="none"
                                            loop
                                            height="100%"
                                            width="100%"
                                            // onMouseOver={playMovie}
                                            // onMouseOut={stopMovie}
                                            onClick={(e) =>
                                              handleVideoSource(
                                                video_files[
                                                  video_files.findIndex(
                                                    (obj) =>
                                                      obj.quality === "hd" &&
                                                      obj.width === 1920
                                                  )
                                                ].link
                                              )
                                            }
                                          /> */}
                                          <ReactPlayer 
                                            url={`${
                                              video_files[
                                                video_files.findIndex(
                                                  (obj) => obj.quality === "sd"
                                                )
                                              ].link
                                            }#t=1.5`} 
                                            className="w-100 react-player"
                                            height="90px"
                                            id={`video_player_${id}`}
                                            light={`${image}`}
                                            onError={e => console.log('onError', e)}
                                            key={id}
                                            onClickPreview={(e) =>
                                              handleVideoSource(
                                                video_files[
                                                  video_files.findIndex(
                                                    (obj) =>
                                                      obj.quality === "hd" &&
                                                      obj.width === 1920
                                                  )
                                                ].link
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    )
                                  )}
                              </>
                            )}
                            {available === 1 && (
                              <p className="text-center p-5">
                                Result Not Found!
                              </p>
                            )}
                          </div>

                          <div
                            className="btn-group btn-group-toggle mt-2"
                            data-toggle="buttons"
                            style={{ float: "right" }}
                          >
                            <label className="btn bg-transparent px-0">
                              <button
                                className="bg-secondary border-0 text-white"
                                disabled={pageNumber <= 1}
                                onClick={() => setpageNumber(pageNumber - 1)}
                              >
                                <FcPrevious /> Prev
                              </button>
                            </label>

                            <label
                              className={`btn bg-transparent px-0 ${
                                pageNumber >= 1 && "active"
                              }`}
                            >
                              <button
                                className="bg-secondary border-0 text-white"
                                onClick={() => setpageNumber(pageNumber + 1)}
                              >
                                Next <FcNext />
                              </button>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="row">
                    {media.length > 0 &&
                      media.map((single) => {
                        return (
                          <>
                            {/* {single.Key !== "" && single.Key.includes(".mp4") && ( */}

                            <div
                              className="col-xl-4 col-lg-4 col-md-4"
                              key={single.Key}
                            >
                              <div className="vd_cl completed">
                                <div className="series_vd position-relative">
                                  <video
                                    src={`${single.Key}#t=1.5`}
                                    //   preload="none"
                                    loop
                                    height="100%"
                                    width="100%"
                                    // onMouseOver={playMovie}
                                    // onMouseOut={stopMovie}
                                  />
                                  <a
                                    href="#0"
                                    className="hvr_play align-items-center justify-content-center"
                                    onClick={(e) =>
                                      handleVideoSource(single.Key)
                                    }
                                    style={{ height: "94%" }}
                                  >
                                    <img
                                      src={`${process.env.PUBLIC_URL}/assets/images/v_play.png`}
                                      alt="img"
                                      style={{ height: "29px", opacity: ".7" }}
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>

                            {/* )} */}
                          </>
                        );
                      })}
                    {media.length === 0 && (
                      <p className="text-center">
                        <b>
                          You have not uploaded or added any video yet.
                          <br />
                          Please upload your video{" "}
                        </b>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoBackgroundModal;
